"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var naturalComparator = function (left, right) {
    if (typeof left === "string" && typeof right === "string") {
        return left.localeCompare(right);
    }
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
};
var nullsDecorator = function (comparator, nullsFirst) { return function (left, right) {
    var leftIsNull = left === undefined || left === null;
    var rightIsNull = right === undefined || right === null;
    if (leftIsNull && rightIsNull) {
        return 0;
    }
    if (leftIsNull) {
        return nullsFirst ? -1 : 1;
    }
    if (rightIsNull) {
        return nullsFirst ? 1 : -1;
    }
    return comparator(left, right);
}; };
/**
 * Create an Ordering object from a Comparator. Invoking the resulting object as a function will
 * yield the same results as calling the comparator.  Invoking any of the member functions will result
 * in a NEW ordering object.  These are intended to be chained.
 *
 * @param comparator The comparator to create an ordering from
 */
exports.fromComparator = function (comparator) {
    return Object.assign(comparator, {
        nullsFirst: function () { return exports.fromComparator(nullsDecorator(comparator, true)); },
        nullsLast: function () { return exports.fromComparator(nullsDecorator(comparator, false)); },
        reverse: function () { return exports.fromComparator(function (left, right) { return comparator(right, left); }); },
        fromMappedField: function (mapper) { return exports.fromComparator(function (left, right) {
            return comparator(mapper(left), mapper(right));
        }); }
    });
};
/**
 * Create a natural ordering.  If the input type is a string a localeCompare is performed.  Otherwise
 * the '<' and '>'  operators are used.
 */
exports.natural = function () { return exports.fromComparator(naturalComparator); };
/**
 * Create an ordering from an array.  Inputs will be compared based on their position in the provided array.
 * null/undefined values will be at the end.  Any values that aren't found in the array will be naturally sorted
 * right before the null/undefined values at the end.
 *
 * @param order The order to sort elements by.
 */
exports.arrayOrder = function (order) {
    return exports.fromComparator(function (left, right) {
        var leftIndex = order.indexOf(left);
        var rightIndex = order.indexOf(right);
        if (leftIndex === -1 && rightIndex === -1) {
            return naturalComparator(left, right);
        }
        if (leftIndex === -1) {
            return 1;
        }
        if (rightIndex === -1) {
            return -1;
        }
        return leftIndex - rightIndex;
    })
        .nullsLast();
};
//# sourceMappingURL=ordering.js.map